export const TIPOS = [
  { value: "m", label: "Motorista" },
  { value: "A", label: "Acompanhante" },
  { value: "M", label: "Motorista" },
  { value: "a", label: "Acompanhante" },
];

export const getTipoLabel = (tipo) =>
  TIPOS.find((t) => t.value === tipo)?.label ?? "—";
